export const cookieConsent = () => {
    const OptanonCookie = document.cookie
    .split("; ")
    .find((row) => row.startsWith("OptanonConsent="))

    try {
        const groups = decodeURIComponent(OptanonCookie)
            .split('&')
            .find(option => option.startsWith("groups="))
        
        const consent = groups.split('=')[1]
            .split(',')
            .find(val => val.startsWith('C0002'))
            .split(':')[1]
        
        return consent === '1'

    } catch(e) {
        return false
    }
}

// Managing keyboard navigation for ebook popup close button on page load
window.addEventListener('DOMContentLoaded', () => {
    const ebook_popup_close = document.querySelector('.ays-pb-modal-close')
    if( ebook_popup_close ){
      ebook_popup_close.setAttribute('role', 'button')
      ebook_popup_close.setAttribute('aria-label', 'Chiudi')
      ebook_popup_close.setAttribute('tabindex', '0')
      ebook_popup_close.addEventListener('keydown', (event) => {
        if( event.key === 'Enter' ) {
          ebook_popup_close.click()
        }
      })
    } 
})